var styles = {"fieldTextContainer":"text-module_fieldTextContainer__Pxipi"};

export { styles as default };
//# sourceMappingURL=text.module.scss.js.map
